import { FieldDescription } from './user-form.interface';

export const partnerFields: FieldDescription[] = [
  {
    name: 'username',
    type: 'text',
    label: 'Название организации',
    placeholder: '',
    required: true,
  },
  {
    name: 'tax_code',
    type: 'text',
    label: 'ИНН',
    placeholder: 'Укажите ИНН',
    required: true,
  },
  {
    name: 'reg_number',
    type: 'text',
    label: 'ОГРН',
    placeholder: 'Укажите ОГРН',
    required: true,
  },
  {
    name: 'city_ids',
    type: 'select_cities',
    label: 'Город указания услуг(возможно несколько)',
    placeholder: 'Укажите города через запятую',
    required: true,
  },
  {
    name: 'cities',
    type: 'hidden',
  },
  {
    name: 'last_name',
    type: 'text',
    label: 'Фамилия контактного лица',
    placeholder: 'Укажите фамилию контактного лица',
    required: true,
  },
  {
    name: 'first_name',
    type: 'text',
    label: 'Имя контактного лица',
    placeholder: 'Укажите имя контактного лица',
    required: true,
  },
  {
    name: 'middle_name',
    type: 'text',
    label: 'Отчество контактного лица',
    placeholder: 'Укажите отчество контактного лица',
    required: true,
  },
  {
    name: 'contact_phone',
    type: 'text',
    label: 'Телефон для связи с контактным лицом',
    placeholder: 'Укажите номер телефона контактного лица',
    required: true,
  },
  {
    name: 'website',
    type: 'text',
    label: 'Сайт организации',
    placeholder: 'Укажите ссылку на сайт организации',
    sublabel: 'Введите корректный адрес формата http(s)://ветераны.рф',
  },
  {
    name: 'client_phone',
    type: 'text',
    label: 'Номер телефона для клиентов',
    placeholder: 'Укажите номер телефона для клиентов',
  },
  {
    name: 'description',
    type: 'textarea',
    label: 'Описание',
    placeholder: 'Описание вашей организации',
  },
  {
    name: 'comment',
    type: 'textarea',
    label: 'Комментарий',
    placeholder: 'Дополнительная информация',
  },
  {
    name: 'agreement',
    type: 'checkbox',
    label: `Согласен(-а) на обработку <a href="/assets/docs/agreement.docx" target="_blank" rel="noopener">персональных данных</a>.`,
  },
  {
    name: 'photo_id',
    type: 'hidden',
  },
];



// WEBPACK FOOTER //
// ./src/app/accounts/user-form/partner.fields.ts